import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

const PaymentCanceled = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Card className="w-full max-w-md mx-4">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mb-4">
            <XCircle className="w-8 h-8 text-amber-600" />
          </div>
          <CardTitle className="text-2xl">Pagamento Cancelado</CardTitle>
          <CardDescription>
            O pagamento foi cancelado. Você pode tentar novamente quando quiser.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            <Button 
              onClick={() => navigate('/login')} 
              className="w-full"
              data-testid="back-to-login-btn"
            >
              Voltar ao Login
            </Button>
            <p className="text-xs text-muted-foreground text-center">
              Precisa de ajuda? Entre em contato: <a href="mailto:suporte@agrolinkbr.com.br" className="text-primary hover:underline">suporte@agrolinkbr.com.br</a>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCanceled;
